// src/utils/tutor/getTutorStudents.js
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";

/**
 * Fetch all students and their most recent activity
 */
export async function getTutorStudents() {
  const usersSnap = await getDocs(collection(db, "users"));
  const students = [];

  for (const userDoc of usersSnap.docs) {
    const userData = userDoc.data();
    if (userData.role !== "student") continue;

    // Fetch most recent assignment by assignedAt (NOT lastSavedAt)
    const assignmentsRef = collection(
      db,
      "users",
      userDoc.id,
      "assignments"
    );

    const assignmentQuery = query(
      assignmentsRef,
      orderBy("assignedAt", "desc"),
      limit(1)
    );

    const assignmentSnap = await getDocs(assignmentQuery);
    const assignment = assignmentSnap.docs[0]?.data();

    const lastActiveDate =
      assignment?.lastSavedAt?.toDate?.() ??
      assignment?.assignedAt?.toDate?.() ??
      null;

    students.push({
      id: userDoc.id,
      firstName: userData.firstName ?? "",
      lastName: userData.lastName ?? "",
      email: userData.email ?? "",

      // 🔥 REQUIRED for dashboard signup events
      createdAt: userData.createdAt ?? null,

      // Used by table + dashboard
      lastActive: lastActiveDate,
      recentAssignment: assignment?.packetName ?? null,
      recentScore:
        assignment?.correct != null && assignment?.questionCount != null
          ? `${assignment.correct} / ${assignment.questionCount}`
          : null,
    });
  }

  return students;
}
